"use client";

import styled from "styled-components";
import Input from "../input";
import Icon from "@/components/icon";

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  left: 15px;
  top: 50%;
  margin-top: -9px;

  svg {
    transition: 0.3s easy-out;
    stroke: var(--borderGraySearch);
    width: 18px;
    height: 18px;
  }
`;

export const InputComponent = styled(Input)`
  border: 1px solid var(--borderGraySearch);
  height: 36px;
  min-width: 124px;
  border-radius: 7px 0 0 7px;
  box-shadow: none !important;
  padding-right: 15px;
  background: var(--whiteGray);
  font-family: "Roboto Light";
  font-size: 15px;
  color: var(--textLight);
  height: 42px;
  display: block;

  &:focus {
    border-color: var(--primaryAndPurple);
  }

  &::placeholder {
    color: var(--placeholderColor);
  }
`;

export const BoxDescription = styled.div`
  padding: 9.25px 10px;
  border: 1px solid var(--borderColor);
  border-left: 0;
  border-radius: 0 7px 7px 0;
  background: var(--backgroundColorCard);
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  font-size: 14px;
  color: var(--textLight);
`;
